import { CarbonBudgetOutput } from '@/types';
import { Content, H2, Inline, InlineItem, Stack, Text } from '@kinesis/bungle';
import { renderValue, renderUnit } from '@/data/units';
import { BudgetIndicator } from './budget-indicator';

const BudgetIndicators = (props: BudgetIndicatorsProps) => {
  const { budget, total } = props;
  return (
    <Content overflow='visible' padding='none' alignX='stretch'>
      <Stack space='medium'>
        <Stack space='xsmall'>
          <H2>Remaining carbon budget at 2050</H2>
          {total !== undefined && (
            <Text tone='secondary'>
              The carbon budget is {renderValue(total, budget.unit)}{' '}
              {renderUnit(budget.unit)}, shared by all three evaluations.
            </Text>
          )}
        </Stack>

        <Inline>
          <InlineItem sizing='fill-container'>
            <BudgetIndicator
              policy='current'
              unit={budget.unit}
              value={budget.current}
            />
          </InlineItem>
          <InlineItem sizing='fill-container'>
            <BudgetIndicator
              policy='intermediate'
              unit={budget.unit}
              value={budget.intermediate}
            />
          </InlineItem>
          <InlineItem sizing='fill-container'>
            <BudgetIndicator
              policy='aggressive'
              unit={budget.unit}
              value={budget.aggressive}
            />
          </InlineItem>
        </Inline>
      </Stack>
    </Content>
  );
};

export type BudgetIndicatorsProps = {
  budget: CarbonBudgetOutput;
  // The budget scalar itself (scope unit) — the new-model evaluation
  // states it; legacy only stated the remainders.
  total?: number;
};
export { BudgetIndicators };
